import { memo } from 'react';
import { PlanSwitcherProps } from './PlanSwitcher.types';
import styles from './styles.module.scss';

const PlanSwitcher = memo<PlanSwitcherProps>(({ selectedPlan, setSelectedPlan }) => (
  <div className={styles.planSwitcherContainer}>
    {/* slider */}
    <div className={styles.slider} data-selected={selectedPlan} aria-hidden="true" />

    <button type="button" onClick={() => setSelectedPlan('monthly')}>
      Monthly
    </button>
    <button
      type="button"
      className={styles.yearlyContainer}
      onClick={() => setSelectedPlan('yearly')}
    >
      <span>Yearly</span>
      <span className={styles.discount}>Save 20%</span>
    </button>
  </div>
));

export default PlanSwitcher;
